// 9fbef606107a605d69c0edbcd8029e5d
import { PAGE_LABELS_MAPPING } from '@tcp/core/src/reduxStore/constants';
import { loadComponentLabelsData } from '@tcp/core/src/reduxStore/actions';
import constants from './StoreDetail.constants';

// TBD: Update actions for container components with contextual ones
export const setNearByStore = (payload) => ({
  type: constants.SET_SUGGESTED_STORE,
  payload,
});

export const setNearByStoreLoading = (payload) => ({
  type: constants.SET_SUGGESTED_STORE_LOADING,
  payload,
});

export const getNearByStore = (payload) => ({
  type: constants.GET_SUGGESTED_STORE,
  payload,
});

export const getCurrentStoreInfo = (payload) => ({
  type: constants.GET_CURRENT_STORE,
  payload,
});

export const setCurrentStoreInfo = (payload) => ({
  type: constants.SET_CURRENT_STORE,
  payload,
});

export function setModuleXContent(payload) {
  return {
    payload,
    type: constants.SET_MODULEX_CONTENT,
  };
}

export function getModuleXContent(payload) {
  return {
    payload,
    type: constants.GET_MODULEX_CONTENT,
  };
}

export const setStoreDetailLoadingState = (payload) => ({
  type: constants.SET_LOADING_STORE_DETAIL_STATUS,
  payload,
});

export const initActions = [
  (args) => loadComponentLabelsData({ category: PAGE_LABELS_MAPPING['store-locator'][1], ...args }),
];

export const fetchProductsRequest = (payload) => ({
  type: constants.FETCH_PRODUCTS_REQUEST,
  payload,
});

export const resetStoreSpecialProducts = (payload) => ({
  type: constants.RESET_STORE_SPECIAL_PRODUCTS,
  payload,
});

export const fetchProductsSuccess = (data) => ({
  type: constants.FETCH_PRODUCTS_SUCCESS,
  data,
});

export const fetchProductsFailure = (error) => ({
  type: constants.FETCH_PRODUCTS_FAILURE,
  error,
});
